export function assigneeLabel(assignee) {
  if (!assignee) return '';
  if (assignee.kind === 'agent') return assignee.name || assignee.agent_id || assignee.id || 'Agente';
  return assignee.name || assignee.id || '';
}

export function buildTicketDeepLink(row) {
  if (!row?.ticket_id) return '/tickets';
  const params = new URLSearchParams();
  params.set('ticket', row.ticket_id);
  if (row.capsule_id) params.set('capsule', row.capsule_id);
  if (row.row_type === 'task' && row.task_id) {
    params.set('task', row.task_id);
    params.set('tab', 'board');
  } else {
    params.set('tab', 'detail');
  }
  return `/tickets?${params.toString()}`;
}
